<template>
  <div v-if="dataEle" id="components-back-top-demo-custom">
    <a-back-top :target="sss">
      <img src="./gotop.svg" alt="" />
      <div class="ant-back-top-inner">
        <a-icon type="vertical-right" />
        回到顶部
      </div>
    </a-back-top>
  </div>
</template>
<script>
  export default {
    props: ['dataEle'],
    data() {
      return {}
    },
    mounted() {},
    methods: {
      sss() {
        return this.dataEle
      }
    }
  }
</script>
<style lang="less" scoped>
  .ant-back-top {
    width: 90px;
    right: 0;
    height: auto !important;
    color: #fff;
    text-align: center;
    img {
      width: 42px;
      height: auto;
      background-color: #fff;
    }
    .ant-back-top-inner {
      width: 100%;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      background: linear-gradient(77deg, #a78bfa 0%, #7493ff 100%);
      box-shadow: 0px 2px 8px 0px rgba(60, 100, 239, 0.19);
      border-radius: 50px 0px 0px 50px;
      .anticon {
        transform: rotateZ(90deg);
      }
    }
  }
</style>
